export default __webpack_public_path__ + "static/retirement-planning-app-493952f87863821bc673b0e080be0a52.webp";